// extracted by mini-css-extract-plugin
module.exports = {"innerSection":"SectionHowTo-module--innerSection--1tafN","link":"SectionHowTo-module--link--1F6JP","banners":"SectionHowTo-module--banners--1bHoM"};